import { Editor, TinyMCE } from "tinymce";
import { addDefaultMenus } from "./DeleteFeature";
import { editing } from "./Utils";

declare let tinymce: TinyMCE;

interface MenuItem {
    name:string;
    icon: string;
    text: string;
    action(editor:Editor, command:string):void;
}

interface FeatureValidator {
    addToEditor(editor:Editor):void;
    addButton(editor:Editor):void;
    addMenuItem(editor:Editor, item:MenuItem):string;
    addMenuItems(editor:Editor):string;
    addContextMenu(editor:Editor):void;
}

interface FeatureConfig {
    featureName:string;
    icon: string;
    tooltip?: string;
    id: string;
    menuItems: Array<MenuItem>;
    editor?:Editor;
    buttonAction(command:string):void;
    commandAction(data:Object):void;
}

/**
 * 
 */
export class FeatureClass implements FeatureValidator{
    featureName = "Feature";
    icon = 'select-all';
    menuItems = [];
    id = '';
    tooltip = '';
    command:string;
    editor:Editor;
    buttonAction = (command:string) => {};
    commandAction = (data:Object) => {};
    constructor(config:FeatureConfig){
        this.featureName = config.featureName;
        this.icon = config.icon;
        this.id = config.id;
        this.tooltip = config.tooltip;
        this.menuItems = config.menuItems;
        this.command = "insert" + this.featureName;
        this.editor = config.editor;
        this.buttonAction = () => {
            const editor = tinymce.get("task-editor");
            if (editor !== undefined){
                editor.selection.collapse(false);
            }
            config.buttonAction(this.command)
        };
        this.commandAction = (data) => {config.commandAction(data)};
    }
    addToEditor(editor:Editor){
        this.addButton(editor);
        this.addContextMenu(editor);
        this.addCommand(editor);
    }
    addButton(editor:Editor){
        editor.ui.registry.addButton(this.featureName, {
            text: '',
            tooltip: this.tooltip,
            icon: this.icon,
            onAction: () => {
                window["node"] = false;
                this.buttonAction(this.command);
            }
        })
    }
    addMenuItem(editor:Editor, item:MenuItem){
        editor.ui.registry.addMenuItem(item.name, {
            icon: item.icon,
            text: item.text,
            onAction: () => {
                item.action(editor, this.command);
            }
        })
        return item.name;
    }
    addMenuItems(editor:Editor){
        let items = '';
        this.menuItems.forEach((item) => {
            items += this.addMenuItem(editor, item);
            items += ' ';
        })
        items += addDefaultMenus(editor);
        
        return items;
    }
    addContextMenu(editor:Editor){
        const items = this.addMenuItems(editor);
        editor.ui.registry.addContextMenu(this.featureName, {
            update: (element) => {
                return !editing(element, [this.id]) ? '' : items;
            }
        });
    }
    addCommand(editor:Editor){
        editor.addCommand(this.command, (data) => {
            this.commandAction(data);
        })
    }
}

/**
 * Params
 * featureName: "Name of feature" -> used for registration in tinyMCE
 * id: "Id given to element -> used to identify mouse point in order to show context-menu
 */